import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ROUTES } from '~console/app/~shared/constants/routes.constants';
import { BaseAuthComponent } from '../../abstract-components/base-auth.component';

@Component({
  selector: 'login',
  standalone: false,
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoginComponent extends BaseAuthComponent {
  title = this.isSandboxEnvironment
    ? 'Environnement Sandbox'
    : 'Portail Entreprise';

  description =
    'Veuillez renseigner les champs ci-dessous pour accéder à votre espace de gestion des factures électroniques normalisées';

  routes = ROUTES;
}
